import "./CategoryCourses.css";
import React from "react";
import CardsCours from "../../../../Component/CardsCours/CardsCours";
import { ImUserTie } from "react-icons/im";
import { Col, Row } from "react-bootstrap";
import TableCategorie from "../../../../Component/TableCategorie/TableCategorie";
import Pagination from "../../../../Component/Pagination/Pagination";
import { FaDev } from "react-icons/fa";
import { VscProject } from "react-icons/vsc";
import { SiDigitalocean, SiAltiumdesigner } from "react-icons/si";

function template() {
  const cardDat = [
    { icon: <ImUserTie />, nombre: 150, },
    { icon: <ImUserTie />, nombre: 150, },
    { cours: "Marketing", icon: <ImUserTie />, nombre: 150, },
    { cours: "Marketing", icon: <ImUserTie />, nombre: 150, }
  ]
  const cardData = [
    { cours: "Informatique", texte: 'students', icon: <FaDev />, total: 300, nombre: 150, couleur: 'red' },
    { cours: "Design", texte: 'students', icon: <SiAltiumdesigner />, total: 300, nombre: 150, couleur: 'blue' },
    { cours: "G-Projet", texte: 'students', icon: <VscProject />, total: 300, nombre: 150, couleur: "green" },
    { cours: "Marketing", texte: 'students', icon: <SiDigitalocean />, total: 300, nombre: 150, couleur: "#754ffe" }

  ]
  return (
    <div className="categorie-cours">
      <Row>
        {
          cardData.map(({ cours, texte, icon, nombre, couleur, total }, index) =>
            <Col lg={3} md={6} key={index}>
              <CardsCours
                cours={cours}
                icon={icon}
                nombre={nombre}
                couleur={couleur}
                texte={texte}
                total={total}
              />
            </Col>
          )
        }
      </Row>

      <TableCategorie />
      <Pagination />
    </div>
  );
}

export default template;
